import { render, staticRenderFns } from "./app-secure-menu-comp.vue?vue&type=template&id=39146bb5&scoped=true&"
import script from "./js/app-secure-menu-comp.js?vue&type=script&lang=js&"
export * from "./js/app-secure-menu-comp.js?vue&type=script&lang=js&"
import style0 from "./app-secure-menu-comp.vue?vue&type=style&index=0&id=39146bb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39146bb5",
  null
  
)

export default component.exports